

















































import {AxiosResponse} from 'axios';
import { Component, Vue, Watch } from 'vue-property-decorator';
import DataSource from 'devextreme/data/data_source';
import {alert, confirm} from 'devextreme/ui/dialog';

import TableGrid from '@/components/TableGrid/grid.vue';
import DButton from '@/components/DButton/button.vue';
import BackupScheduler from './components/scheduler.vue';
import base_ds from '@/services/base_datasource_service';
import request from '@/utils/request';
import notify_service from "@/services/notify_service";
import WebSocketService from '@/services/websocket_service';
import * as _ from 'lodash';

const route_ns = 'admin/backup';

@Component({
  name: 'Backup',
  components: {
    TableGrid,
    DButton,
    BackupScheduler
  }
})
export default class extends Vue {
  private dataSource: DataSource | null = null;
  private tableColumns: any[] = [];
  private showScheduler: boolean = false;

  created() {
    // @ts-ignore
    this.$options.sockets.onmessage = (data: any) => {

      let res = WebSocketService.handleMsg(data, 'backup_result');
      if (!_.isNil(res)) {

        if ((res.success) && this.dataSource) {
          this.dataSource.reload().catch((reason: any) => {
          });
          notify_service.success('Успешно завершен процесс резервного копирования.', false, 0);

        } else if (!res.success) {
          notify_service.error(`Ошибка создания резервной копии: ${res.message}`, false, 0);
        }
      }

      res = WebSocketService.handleMsg(data, 'backup_restore_result');
      if (!_.isNil(res)) {
        if ((res.success) && this.dataSource) {
          //

        } else if (!res.success) {
          notify_service.error(`${res.message}`, false, 0);
        }
      }

    }
  }

  private destroyed(): void {
    // @ts-ignore
    delete this.$options.sockets.onmessage
  }

  protected mounted(): void {

    this.dataSource = base_ds.getBaseDataSource(route_ns, 'name');
    this.initColumns();
  }



  private initColumns(): void {
    this.tableColumns = [
      {
        dataField: 'name',
        dataType: 'string',
        caption: 'Имя файла'
      },
      {
        dataField: 'size',
        dataType: 'number',
        caption: 'Размер'
      },
      {
        type: 'buttons',
        buttons: [
          {
            icon: 'video',
            hint: 'Восстановить',
            ssClass: 'dx-link__goto',
            visible: true,
            onClick: this.onRestoreBackup
          },
          {
            icon: 'remove',
            hint: 'Удалить',
            cssClass: 'dx-link__delete',
            visible: true,
            onClick: this.onDelete
          }
        ]
      }
    ];
  }

  async onAdd() {
    try {
      const response: AxiosResponse['data'] = await request({
        url: route_ns,
        method: 'post',
        data: {}
      });

      if (response?.status === 'error') {
        notify_service.error(`Ошибка запуска резервного копирования: ${response?.message}`, false, 0);

      } else {
        notify_service.success('Процесс резервного копирования запущен. После завершения будет выведено сообщение.', false, 5000);
        setTimeout(() => {
          if (this.dataSource) {
            this.dataSource.reload()
              .catch((reason: any) => {
                if (reason !== 'canceled') throw reason;
              });
          }
        }, 5000);
      }

    } catch (e) {
      notify_service.error(`Ошибка запуска резервного копирования`, false, 0);
    }

  }

  private onDelete(e: any): void {
    confirm(`Файл ${e.row.data.name} будет удалён безвозвратно. Продолжать?`, '')
      .then((answer: boolean) => {
        if (answer) {
          request({
            url: `${route_ns}/${e.row.data.name}`,
            method: 'delete'
          })
            .then((response: AxiosResponse['data']) => {
              if (this.dataSource) {
                this.dataSource.reload().catch((reason: any) => { if (reason !== 'canceled') throw reason; });
              }
            });
        }
      });
  }

  private onRefresh(): void {
    if (this.dataSource) {
      this.dataSource.reload().catch((reason: any) => { if (reason !== 'canceled') throw reason; });
    }
  }

  private onRestoreBackup(e: any): void {
    if (!e.row.data?.name) {
      return;
    }
    confirm(`База данных будет восстановлена из резервной копии ${e.row.data.name}. Сервер будет остановлен на время восстановления БД. Продолжать?`, 'Восстановление БД')
      .then(async (answer: boolean) => {
        if (answer && e.row.data.name) {
          try {
            const response: AxiosResponse['data'] = await request({
              url: `${route_ns}/${e.row.data.name}`,
              method: 'put',
              data: e.row.data,
            });

            if (response?.status !== 'error' && this.dataSource) {
              this.dataSource.reload().catch((reason: any) => { if (reason !== 'OK') throw reason; });

            } else if (response?.message) {
              notify_service.error(`Ошибка востановления из резервной копии: ${response.message}`, false, 0);
            }

          } catch (e) {
            notify_service.error(`Ошибка востановления из резервной копии`, false, 0);
          }

        }
      });
  }

  private empty(): void {

  }


}
